<div class="position-relative">

    <ngx-spinner name="spVerTipoMovimiento" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>
    <form [formGroup]="form">
      <div class="row">
        <div class="col-lg-6">
          <mat-form-field>
            <input placeholder="Descripción" type="text" formControlName="Descripcion" matInput>
            <mat-error *ngIf="f.Descripcion.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-slide-toggle matTooltip="Resta/Descuenta" style="padding-top: 10px;"  formControlName="Resta">Resta/Descuenta</mat-slide-toggle>
        </div>
      </div>

      <!-- Sólo lectura: se muestra el icono, no se puede cambiar desde acá -->
      <div class="row" *ngIf="tipoMovimientoDto">
        <div class="col-lg-6">
          <span class="etiqueta-icono">Icono</span>
          <span class="valor-icono">
            <mat-icon [color]="tipoMovimientoDto.icono ? 'primary' : ''">
              {{ tipoMovimientoDto.icono ? tipoMovimientoDto.icono : 'swap_horiz' }}
            </mat-icon>
            <span class="nombre-icono">{{ tipoMovimientoDto.icono ? tipoMovimientoDto.icono : 'Sin icono' }}</span>
          </span>
        </div>
      </div>
      <br>

      <!-- Auditoría al final, igual que en el resto de las vistas de sólo lectura -->
      <app-info-auditoria *ngIf="tipoMovimientoDto && tipoMovimientoDto.id > 0"
        entidad="TiposMovimiento" [id]="tipoMovimientoDto.id">
      </app-info-auditoria>

      <mat-divider></mat-divider>
      <br>
      <div class="row">
        <div class="col-lg-3">
          <button mat-button (click)="closeDialog()" mat-flat-button color="warn">Cancelar</button>
        </div>
      </div>
    </form>
  </div>
